export const cachePromise = (func) => {
  const m = new Map();
  return async function (...args) {
    const params = args.map(a => a instanceof FormData ? Object.fromEntries(a) : a);
    const key = JSON.stringify(params);

    if (!m.has(key)) {
      const p = async () => {
        const res = await func(...args);
        m.delete(key);
        return res;
      }
      m.set(key, p());
    }
    return m.get(key);
  }
}